import type { ReactElement } from 'react';
import FeatureNavLayout from '@/shared/surfaces/FeatureNavLayout';
import type { FeatureNavItem } from '@/shared/surfaces/FeatureNavTypes';
import { SPEND_COST_NAV } from './SpendCostNav';

const COST_BASE = '/cost';

function costNavItems(): FeatureNavItem[] {
    return SPEND_COST_NAV.map((item) => ({
        path: item.slug === '' ? COST_BASE : `${COST_BASE}/${item.slug}`,
        label: item.label,
        icon: item.icon,
    }));
}

/**
 * The Cost surface shell: a full-height interior sub-nav column (the
 * Cost-by-Provider ranked list, forecast, license fit, and cost trend) beside
 * its own scrollable content area. Drill-ins (provider/model records) render
 * inside the outlet so the rail keeps the current view highlighted.
 */
export default function CostLayout(): ReactElement {
    return <FeatureNavLayout title="Cost" ariaLabel="Cost view" groups={[{ items: costNavItems(), selectGroupLabel: 'Cost' }]} />;
}
